import React from "react"
import classNames from "classnames"
import LazyLoad from "react-lazy-load"
import PropTypes from "prop-types"
import getWidth from "../../../utils/gridWidth"
import getCdnSrcset from "../../../utils/srcSetHelper"
import { getCdnImage as getImageUrl } from "../../../utils/ImageManager"

const Image = props => {
    const { image, imageset, styles } = props
    const widthClass = getWidth(image && image.componentWidth)
    let src = ""
    if (image) {
        src = getImageUrl(image.image && image.image.url)
    }

    if (src) {
        return (
            image? (
                <LazyLoad offset={-20}>
                    <>
                    <img
                        key={image.sys.id}
                        src={src}
                        alt={image.altText}
                        className={classNames(widthClass, styles)}
                    />
                    </>
                </LazyLoad>
            ) : <></>
        )
    }
    return (
        imageset? (
            <div
                className={classNames(widthClass, imageset.styles && imageset.styles)}
            >
                <picture>
                    <LazyLoad offset={-20}>
                        <>
                        <source
                            srcSet={getCdnSrcset(
                                imageset.desktopImage &&
                                    imageset.desktopImage.url,
                                1600,
                                768
                            )}
                            media='(min-width: 768px)'
                        />

                        <img
                            className={classNames(widthClass)}
                            src={getImageUrl(
                                imageset.smartphoneImage &&
                                    imageset.smartphoneImage.url,
                                750
                            )}
                            alt={imageset.altText}
                        />
                        </>
                    </LazyLoad>
                </picture>
            </div>
        ) : <></>
    )
}

Image.propTypes = {
    image: PropTypes.oneOfType([PropTypes.object]),
    imageset: PropTypes.oneOfType([PropTypes.object]),
    styles: PropTypes.string
}

export default Image
